import React, { useEffect } from 'react'
import Footer from '../layouts/Footer'
import Header from '../layouts/Header'
import './Cart.css'
import { Link } from 'react-router-dom'
import { RootState, useAppDispatch, useAppSelector } from '../../store'
import { formatUSD } from '../../utils/formatter'
import { CartItem, EmptyCart } from './components'
import {
  deleteItemInCartAPI,
  getCartAPI,
  modifyItemInCartAPI
} from '../../redux/actions/cart-actions'

function Cart() {
  const dispatch = useAppDispatch()
  const { cart } = useAppSelector((state: RootState) => state.carts)
  const items = cart ?? {}
  const total = () => {
    const totalPrice = items?.reduce((cur, item) => {
      cur += (item.product?.price || 0) * item.quantity
      return cur
    }, 0)
    return totalPrice
  }

  const handleDeleteItemInCart = (itemID: string) => {
    const confirmDel = window.confirm('delete this product from cart ?')
    if (confirmDel) {
      dispatch(deleteItemInCartAPI(itemID))
    }
  }
  const modifyQuantity = (itemID: string, type: 'add' | 'sub') => {
    dispatch(modifyItemInCartAPI({ itemID, type }))
  }

  useEffect(() => {
    dispatch(getCartAPI())
  }, [])

  return (
    <div className="main">
      <Header />

      <div className="cart-main">
        <h1 className="yourcart">Your cart</h1>
        {(items || []).length >= 1 ? (
          <div className="cart">
            <div className="cart__infor">
              <table>
                <thead>
                  <tr>
                    <td className="hidden-for-medium-only">Remove</td>
                    <td>Product in cart</td>
                    <td className="hidden-for-medium-only">View</td>
                  </tr>
                </thead>

                <tbody>
                  {(items || []).map((item, index) => {
                    return (
                      <CartItem
                        key={index}
                        item={item}
                        handleRemoveCart={handleDeleteItemInCart}
                        modifyQuantity={modifyQuantity}
                      />
                    )
                  })}
                </tbody>

                <tfoot>
                  <tr>
                    <td className="hidden-for-medium-only">Remove</td>
                    <td>Product in cart</td>
                    <td className="hidden-for-medium-only">View</td>
                  </tr>
                </tfoot>
              </table>
            </div>
            <Link className="backShop" to="/shop">
              shopping now!
            </Link>
            <div className="cart__ck">
              <div className="__ck--wrap">
                <p>cart total : {formatUSD(total())}</p>
                <p>Shoping & taxex caculated at checkout</p>
                <Link to="/checkout" className="cart__ck--send">
                  check out
                </Link>
              </div>
            </div>
          </div>
        ) : (
          <EmptyCart />
        )}
      </div>

      <Footer />
    </div>
  )
}

export default Cart
